import { useQuery, useMutation } from "./useApi";
import { gatewayRoutesService } from "../api/gatewayRoutes.service";

export function useGatewayRoutes() {
  return useQuery(() => gatewayRoutesService.getAll(), []);
}

export function useCreateGatewayRoute() {
  return useMutation((body: { serviceName: string; method: string; path: string }) =>
    gatewayRoutesService.create(body),
  );
}

export function useSetGatewayRouteEnabled() {
  return useMutation(({ id, enabled }: { id: string; enabled: boolean }) =>
    gatewayRoutesService.setEnabled(id, enabled),
  );
}

export function useDeleteGatewayRoute() {
  return useMutation((id: string) => gatewayRoutesService.remove(id));
}
